import { render, staticRenderFns } from "./DataSheetConfigContainer.vue?vue&type=template&id=6d20c688&scoped=true"
import script from "./DataSheetConfigContainer.vue?vue&type=script&lang=js"
export * from "./DataSheetConfigContainer.vue?vue&type=script&lang=js"
import style0 from "./DataSheetConfigContainer.vue?vue&type=style&index=0&id=6d20c688&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d20c688",
  null
  
)

export default component.exports